import { Package2, Save, Store, Trash2, User } from 'lucide-react';
import { useEffect, useState } from 'react'

interface props {
    productsOffline: productsOffline
    saveItem: () => void
    deleteItem: () => void
}
interface productsOffline {
    id: number;
    DS_REVENDA: string;
    SK_PESQUISA: number;
    SK_CLIENTE: number;
    DS_NOME_FANTASIA: string | null;
    SK_PRODUTO: string;
    DS_PRODUTO: string;
    VL_PRECO_COMPRA: number;
    QTD_VOLUME_COMPRA: number;
    VL_PRECO_VENDA: number;
    DD_LATITUDE: string;
    DD_LONGITUDE: string;
    IMAGEM: File | null;
    CREATED_AT: string;
}

const CardProduct = ( { productsOffline, saveItem, deleteItem } : props) => {   
  const [preview, setPreview] = useState<string | null>(null)
  
   useEffect(() => {
    if (!productsOffline.IMAGEM) {
      setPreview(null)
      return
    }

    const objectUrl = URL.createObjectURL(productsOffline.IMAGEM)
    setPreview(objectUrl)

    // limpa da memória
    return () => URL.revokeObjectURL(objectUrl)
  }, [productsOffline.IMAGEM])

    return ( 
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden hover:shadow-md transition-all duration-300 h-auto">
            {preview  && (
                <div className="w-full h-40 bg-gray-100 overflow-hidden">
                    <img 
                        src={preview}
                        alt={productsOffline.DS_PRODUTO}
                        className="w-full h-full object-contain hover:scale-105 transition-transform duration-300" 
                    />
                </div>
            )}

            <div className="p-3">
                <h3 className="text-sm font-bold text-gray-900 mb-2 line-clamp-2">{productsOffline.DS_PRODUTO}</h3>

                <div className="space-y-2">
                    <div className="flex gap-1.5">
                        <Store className='text-gray-600 ' size={14} />
                        <div className="flex-1 min-w-0">
                            <p className="text-xs text-gray-900 font-medium truncate">{productsOffline.DS_REVENDA}</p>
                        </div>
                    </div>

                    <div className="flex gap-1.5">
                        <User className='text-gray-600' size={14} />
                        <div className="flex-1 min-w-0">
                            <p className="text-xs text-gray-900 font-medium truncate">{productsOffline.DS_NOME_FANTASIA}</p>
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-2 pt-2 border-t border-gray-100">
                        <div>
                            <p className="text-xs text-gray-500 mb-0.5">Compra</p>
                            <p className="text-sm font-bold text-red-600">
                                R$ {(productsOffline.VL_PRECO_COMPRA).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </p>
                        </div>
                        <div>
                            <p className="text-xs text-gray-500 mb-0.5">Venda</p>
                            <p className="text-sm font-bold text-green-600">
                                R$ {(productsOffline.VL_PRECO_VENDA).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </p>
                        </div>
                    </div>

                    <div className="flex justify-between pt-2 border-t border-gray-100">
                        <div className="flex gap-1.5">
                            <Package2  className='text-gray-600 mt-0.5' size={14} />
                            <p className="text-xs text-gray-900 font-semibold">{productsOffline.QTD_VOLUME_COMPRA} un.</p>
                        </div> 
                    </div>

                    <div className="flex justify-between pt-2 border-t border-gray-100">
                          <div className="flex flex-1 gap-4">
                            <button 
                                className="w-full btn-secondary border border-red-800 font-medium py-2 px-0.5 rounded-lg flex items-center justify-center text-sm gap-1.5 text-red-800" 
                                onClick={() => deleteItem()}
                            >
                                <Trash2 size={18}/>
                                Excluir
                            </button> 
                            <button 
                                className="w-full btn-primary text-white font-medium py-2 px-0.5 rounded-lg flex items-center justify-center text-sm gap-1.5"
                                onClick={() => saveItem()} 
                            > 
                                <Save size={18} />
                                Salvar
                            </button> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CardProduct
